import React from "react";
import { Link } from "react-router-dom";

// Transparent, cropped PNG generated from the brand JPG (white background removed)
export const LOGO_URL = "/logos/fleetroot.png";

const Logo = ({ className = "", height = 26, testid = "nav-logo" }) => (
  <Link to="/" className={`inline-flex items-center ${className}`} aria-label="Fleetroot home" data-testid={testid}>
    <img
      src={LOGO_URL}
      alt="Fleetroot"
      style={{ height, width: "auto" }}
      className="block select-none"
      draggable={false}
    />
  </Link>
);

export default Logo;
